<template lang="pug">
    #app(:style="{background: config.background}")
        router-view(v-if="!loading.config")
        .noPermission(v-if="noPermission && !isLogin")
            logo
            user-nav
</template>

<script>
import { languages, loadLanguageAsync, setI18nLanguage, defaultLang } from "@/locale";
import ls from './utils/local-storage';
import { mapGetters } from 'vuex';
import config from './config';
import _ from 'lodash';
import Logo from 'components/logo';
import UserNav from 'components/user-nav';

export default {
    name: "app",
    components: {
        Logo,
        UserNav
    },
    data () {
        return {
            languages: languages,
            loading: {
                config: true
            },
            noPermission: false
        };
    },
    computed: {
        ...mapGetters({
            config: 'config'
        }),
        isLogin () {
            return this.$route.name === 'login';
        }
    },
    mounted () {
        this.$store.commit("configUpdate", config);
        this.init();
    },
    watch: {
        '$route' (now, old) {
            // 从无需登录的页面跳过来，需要重新请求who/profile类的接口，以确认该用户是否能看到该内容
            if (old.meta.noNeedLogin && !now.meta.noNeedLogin) {
                this.init();
                return;
            }
            // 主页中无component内容，所以跳往default页
            const defaultPage = this.defaultPage();
            if (now.name === 'index' && defaultPage) {
                this.$router.replace(defaultPage);
            } else if (now.name === 'index') {
                this.$router.replace({
                    path: '/logout'
                });
            }
        }
    },
    methods: {
        async init () {
            this.loading.config = true;

            const localeLang = ls.get('lang') || defaultLang;
            // 如果本地存储的语言不是系统默认语言，加载并设置当前语言为本地存储语言
            if (localeLang && _.find(languages, { lang: localeLang }) && localeLang !== this.$i18n.locale) {
                await loadLanguageAsync(localeLang);
            } else {
                setI18nLanguage(localeLang);
            }

            // 登录页什么都不检查，因为什么都没有..
            if (!this.isLogin) {
                this.checkLogin().then(result => {
                    if (!result) {
                        this.$router.push({
                            name: 'login'
                        });
                        return;
                    }
                    this.checkPermissions().then(result => {
                        if (result !== true) {
                            this.noPermission = true;
                            return;
                        }
                        // 如果默认进的是首页，那么自动跳转到 modelList
                        if (this.$route.name === 'index') {
                            this.$router.replace(this.defaultPage());
                        }
                    });
                    
                }).finally(() => {
                    this.loading.config = false;
                });
            } else {
                this.loading.config = false;
            }
        },
        checkLogin () {
            return this.$http.get('/sso/oauth/who').then(resp => {
                const value = _.get(resp, 'body.value', {});
                this.$store.commit('userUpdate', value);
                return true;
            }, () => {
                return Promise.resolve(false);
            });
        },
        checkPermissions () {
            return this.$http.get('mli/profile').then(resp => {
                const platformList = _.get(resp, 'body.value.data.auth_platform_list', {});
                const platform = 'gzzoc';
                if (platformList.indexOf(platform) > -1) {
                    return true;
                } else {
                    this.$message.error(this.$t('noPermission'));
                    return false;
                }
            }, () => {
                return Promise.resolve(false);
            });
        },
        defaultPage () {
            return {
                name: 'modelList'
            };
        }
    }
};
</script>

<style lang="sass">
    #app
        height: 100%
</style>
